module.exports = __webpack_public_path__ + "img/green_097.3b3e0fe0.png";